import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRessLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 80,
	height: 80,
	viewBox: "0 0 80 80",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M25.7426 48.9406V62.901C25.7426 64.7055 27.2054 66.1683 29.0099 66.1683H50.2475H66.7327C68.5372 66.1683 70 64.7055 70 62.901L70 34.3033C70 32.3268 68.966 30.4943 67.2741 29.4725L42.6105 14.5767C41.0052 13.6071 38.9948 13.6071 37.3895 14.5767L12.7259 29.4725C11.034 30.4943 10 32.3268 10 34.3033V66.1683",
			stroke: "currentColor",
			strokeWidth: 4.75248,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.7426 48.9406V62.901C25.7426 64.7055 27.2054 66.1683 29.0099 66.1683H50.2475H66.7327C68.5372 66.1683 70 64.7055 70 62.901L70 34.3033C70 32.3268 68.966 30.4943 67.2741 29.4725L42.6105 14.5767C41.0052 13.6071 38.9948 13.6071 37.3895 14.5767L12.7259 29.4725C11.034 30.4943 10 32.3268 10 34.3033V66.1683",
			stroke: "currentColor",
			strokeWidth: 4.75248,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M57.5234 13.8907L57.5234 22.5045",
			stroke: "currentColor",
			strokeWidth: 4.75248,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M37.7696 44.7822L41.7964 48.5621C42.9416 49.6371 44.726 49.6346 45.8682 48.5563L56.631 38.396",
			stroke: "currentColor",
			strokeWidth: 4.75248,
			strokeLinecap: "round"
		})
	]
});
export default SvgRessLogo;
